import React from 'react';
import { ChakraProvider, Box } from '@chakra-ui/react';
import ROICalculator from './components/ROICalculator';
import ResultsPage from './components/ResultsPage';

function App() {
  // Check if we have URL parameters that indicate we should show results
  const urlParams = new URLSearchParams(window.location.search);
  const hasResultsParams = urlParams.get('businessDescription') && 
                          urlParams.get('monthlyBudget') && 
                          urlParams.get('averageOrderValue');

  console.log('🎯 App loading...');
  console.log('🔍 URL search params:', window.location.search);
  console.log('📊 Has results params?', hasResultsParams);
  console.log('💼 Business description:', urlParams.get('businessDescription'));
  console.log('💰 Monthly budget:', urlParams.get('monthlyBudget'));

  return (
    <ChakraProvider>
      <Box minH="100vh">
        {hasResultsParams ? <ResultsPage /> : <ROICalculator />}
      </Box>
    </ChakraProvider>
  );
}

export default App; 